<template>
  <b-modal
    v-model="show"
    title="Send mass message"
    size="md-lg"
    centered
    scrollable
    no-close-on-backdrop
    header-bg-variant="primary"
    header-text-variant="white"
    modal-class="new-verification-modal"
    header-class="bg-purple"
    body-class="pt-0"
    @close="closeModal"
  >
    <b-row>
      <b-col class="border p-3">
        <div class="mb-4">
          <p class="d-inline">Select Patients</p>
          <b-link
            v-on:click="resetValues"
            class="d-inline pull-right clear-link"
            >Clear all filters</b-link
          >
        </div>
        <div class="mb-4">
          <p class="d-inline">Name</p>
          <b-link
            v-on:click="nameFilterClear"
            class="d-inline pull-right clear-link"
            >Clear</b-link
          >
          <b-input
            class="mt-2"
            v-on:input="filterEocs"
            v-model="name"
          ></b-input>
        </div>
        <b-row>
          <b-col class="mb-2">
            <div class="mb-2">
              <p class="d-inline">LOC</p>
              <b-link
                v-on:click="locFilterClear"
                class="d-inline pull-right clear-link"
                >Clear</b-link
              >
            </div>
            <v-select
              :clearable="false"
              v-on:input="filterEocs"
              v-model="loc"
              :options="locs"
            />
          </b-col>
          <b-col class="mb-2">
            <div class="mb-2">
              <p class="d-inline">Status</p>
              <b-link
                @click="statusFilterClear"
                class="d-inline pull-right clear-link"
                >Clear</b-link
              >
            </div>
            <v-select
              :clearable="false"
              @input="filterEocs"
              v-model="status"
              :options="statuses"
            />
          </b-col>
        </b-row>
        <div class="mb-2 mt-3">
          <p class="d-inline">DOB</p>
          <b-link
            v-on:click="dateFilterClear"
            class="d-inline pull-right clear-link"
            >Clear</b-link
          >
        </div>
        <div class="mb-3">
          <b-row>
            <b-col>
              From
              <date-picker
                @input="filterEocs"
                v-model="startDateFilter"
              ></date-picker>
            </b-col>
            <b-col>
              To
              <date-picker
                @input="filterEocs"
                v-model="endDateFilter"
              ></date-picker>
            </b-col>
          </b-row>
        </div>
        <div class="mb-2 mt-4">
          <p class="d-inline">Appointment date</p>
          <b-link
            v-on:click="dateAppFilterClear"
            class="d-inline pull-right clear-link"
            >Clear</b-link
          >
        </div>
        <div class="mb-4">
          <b-row>
            <b-col>
              From
              <date-picker
                @input="filterEocs"
                v-model="startAppDateFilter"
              ></date-picker>
            </b-col>
            <b-col>
              To
              <date-picker
                @input="filterEocs"
                v-model="endAppDateFilter"
              ></date-picker>
            </b-col>
          </b-row>
        </div>
        <div>
          <p class="d-inline">Provider</p>
          <b-link
            v-on:click="providerFilterClear"
            class="d-inline pull-right clear-link"
            >Clear</b-link
          >
          <v-select
            :clearable="false"
            @input="filterEocs"
            v-model="provider"
            :options="providers"
            class="mt-2"
          />
        </div>
      </b-col>
      <b-col class="border pt-3">
        <div>
          <b-link v-on:click="selectAll" class="d-inline clear-link">{{
            allSelected ? "Clear Selection" : "Select All"
          }}</b-link>
          <p class="d-inline pull-right">
            {{ selectedValues.length }} selected from {{ eocs.length }} patients
          </p>
        </div>
        <b-list-group class="doc-list-group">
          <b-list-group-item
            :key="key"
            v-for="(eoc, key) in eocs"
            href="#"
            class="flex-column align-items-start doc-list-item"
          >
            <div class="p-10">
              <b-container>
                <b-row>
                  <b-col cols="1" align-self="center" @click="selectItem(eoc)">
                    <b-form-checkbox
                      id="checkbox-1"
                      :checked="
                        selectedValues.find(v => v.value == eoc.value) != null
                      "
                      name="checkbox-1"
                      class="b-block"
                    >
                    </b-form-checkbox>
                  </b-col>
                  <b-col>
                    <div class="d-flex flex-row justify-content-between">
                      <b-badge
                        :variant="statusVariant(eoc.data.status)"
                        class="text-white mb-2"
                        >{{ statusText(eoc.data.status) }}
                      </b-badge>
                    </div>
                    <div>
                      <span class="d-block"> {{ eoc.label }}</span>
                      <span class="d-block">
                        DOB:
                        {{ formatDateOnly(eoc.data.patient.dateOfBirth) }}</span
                      >
                      <span v-if="eoc.data.levelOfCare" class="d-block">
                        Current LOC: {{ eoc.data.levelOfCare.name }}</span
                      >
                    </div>
                  </b-col>
                </b-row>
              </b-container>
            </div>
          </b-list-group-item>
          <div
            v-if="!filteredSelection"
            class="d-flex justify-content-center my-2"
          >
            <b-button :disabled="isLastPage" @click="loadMore" variant="primary"
              >Load More</b-button
            >
          </div>
        </b-list-group>
      </b-col>
    </b-row>
    <div class="p-2">
      <p>Message</p>
      <b-textarea v-model="message" class="mt-2" rows="5"></b-textarea>
    </div>
    <template v-slot:modal-footer>
      <div class="pr-2">
        <b-button @click="closeModal" class="secondary mr-2">Close</b-button>
        <b-button
          @click="sendMessage()"
          :variant="
            selectedValues.length > 0 && message ? 'primary' : 'secondary'
          "
          :disabled="selectedValues.length == 0 || !message"
          >Send message to {{ selectedValues.length }} patients</b-button
        >
      </div>
    </template>
  </b-modal>
</template>

<script>
import serviceServer from "../../server/service";
import DatePicker from "../controls/DatePicker";
import { mapGetters, mapActions } from "vuex";
import eocServer from "../../server/eoc";
import scheduleEventServer from "../../server/scheduleEvent";
import userServer from "../../server/user";
import chatMessageServer from "../../server/chatMessage";
import chatServer from "../../server/chat";
import { formatEndDateSql, formatStartDateSql } from "../../helpers/date";
import { mapState } from "vuex";

export default {
  name: "ChatMassMessageModal",
  components: {
    DatePicker
  },
  data() {
    return {
      eocs: [],
      locs: [],
      providers: [],
      selectedValues: [],
      name: "",
      loc: null,
      locSearch: null,
      status: null,
      startDateFilter: "",
      endDateFilter: "",
      startAppDateFilter: "",
      endAppDateFilter: "",
      provider: null,
      allSelected: false,
      statuses: [
        {
          value: "Pending",
          label: "Pending"
        },
        {
          value: "Active",
          label: "Active"
        }
      ],
      isCloseable: false,
      show: true,
      data: [],
      message: "",
      currentPage: 1,
      isLastPage: false,
      filteredSelection: false
    };
  },
  mounted() {
    this.fetchLevelsOfCare();
    this.fetchEocs();
    this.fetchServices();
    this.fetchProviders();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    ...mapActions("client", ["fetchLevelsOfCare"]),
    closeDropdown() {
      this.isCloseable = true;
      this.$refs.dropdown.hide();
    },
    handleHide(bvEvent) {
      if (!this.isCloseable) {
        bvEvent.preventDefault();
      } else {
        this.$refs.dropdown.hide();
      }
    },
    async loadMore() {
      this.currentPage++;
      await this.fetchEocs();
    },
    async fetchEocs() {
      const optionsResult = await eocServer.queryList({
        eocStatus: ["Active", "Pending"],
        deleted: 0,
        allLocations: true,
        page: this.currentPage,
        pageSize: 50
      });
      if (optionsResult.episodesOfCare.length < 50) {
        this.isLastPage = true;
      }
      this.data = optionsResult.episodesOfCare.map(eoc => ({
        value: eoc.id,
        label: this.formatEocObj(eoc),
        data: eoc
      }));
      this.eocs = this.eocs.concat(this.data);
    },
    async fetchServices() {
      const services = await serviceServer.query({
        type: "LevelOfCare"
      });
      this.locs = services
        .filter(levelOfCare =>
          this.levelsOfCareCurrentLocation
            .map(lc => lc.id)
            .includes(levelOfCare.id)
        )
        .map(service => ({
          value: service.id,
          label: `${
            service.billingCodes[0]
              ? service.billingCodes[0].cptCode + " - "
              : ""
          } ${service.name}`,
          data: service
        }));
    },
    async fetchProviders() {
      let users = await userServer.queryImproved();
      users = users.map(user => ({
        value: user.id,
        label: this.formatUser(user),
        data: user
      }));
      this.providers = users.filter(u => u.data.providerInfo);
    },
    async filterByAppointment() {
      const scheduleEvents = await scheduleEventServer.query({
        startDateFrom: this.startAppDateFilter
          ? this.formatDateTimeSql(this.startAppDateFilter)
          : null,
        endDateTo: this.endAppDateFilter
          ? this.formatDateTimeSql(this.endAppDateFilter)
          : null,
        episodeOfCareIds: this.eocs.map(e => e.value),
        types: ["Appointment"],
        allLocations: true,
        userIds: this.provider ? [this.provider.value] : []
      });

      const episodeOfCareIds = scheduleEvents
        .flatMap(obj => obj.episodesOfCare)
        .flatMap(eoc => eoc.episodeOfCare.id);

      this.eocs = this.eocs.filter(eoc =>
        episodeOfCareIds.some(obj => obj === eoc.value)
      );
    },
    async sendMessage() {
      let message = {
        patientIds: [
          ...new Set(this.selectedValues.map(eoc => eoc.data.patient.id))
        ],
        message: this.message,
        dateTime: this.formatDateTimeSql(new Date())
      };

      try {
        await chatMessageServer.sendMany(message);
        await chatServer.sendToPortal(
          {
            tenantName: this.currentTenant,
            receivers: [
              ...new Set(this.selectedValues.map(eoc => eoc.data.patient.id))
            ]
          },
          this.signalRAppUrl
        );
      } catch (error) {
        console.log(error);
        if (error.response.data.date) {
          this.errorMessage = `${
            error.response.data.message
          } ${this.formatDatePretty(error.response.data.date)}`;
        } else {
          this.errorMessage =
            error.response.data.errorCode === "tooMuchOcurrences"
              ? "The amount of events to generate is too big (max 300). Please modify the parameters and try again."
              : error.response.data.message;
        }
        return;
      }
      this.showAlertSuccess();
      this.closeModal();
    },
    selectItem(eoc) {
      let selectedValues = this.selectedValues;
      if (selectedValues.indexOf(eoc) >= 0) {
        const index = selectedValues.indexOf(eoc);
        selectedValues.splice(index, 1);
      } else {
        selectedValues.push(eoc);
      }
      this.selectedValues = selectedValues;
    },
    selectAll() {
      if (!this.allSelected) {
        this.selectedValues = [];
        for (let index = 0; index < this.eocs.length; index++) {
          const eoc = this.eocs[index];
          this.selectedValues.push(eoc);
        }
        this.allSelected = true;
      } else {
        this.selectedValues = [];
        this.allSelected = false;
      }
    },
    async filterEocs() {
      this.selectedValues = [];
      

      let levelOfCareId = null;
      if (this.loc) {
        this.filteredSelection = true;
        levelOfCareId = this.loc.data.id;
      }

      let status = null;
      if (this.status) {
        this.filteredSelection = true;
        status = this.status.value;
      }

      let fromDate = null;
      if (this.startDateFilter) {
        this.filteredSelection = true;
        fromDate = this.startDateFilter;
      }

      let endDate = null;
      if (this.endDateFilter) {
        this.filteredSelection = true;
        endDate = this.endDateFilter;
      }

      let searchPhrase = "";
      if (this.name) {
        this.filteredSelection = true;
        searchPhrase = this.name;
      }

      let provider = "";
      if (this.provider) {
        this.filteredSelection = true;
        provider = this.provider.value;
      }

      const eocs = await eocServer.queryList(
        {
          searchPhrase: searchPhrase,
          eocStatus: status ? [status] : ["Active", "Pending"],
          levelsOfCare: levelOfCareId ? [levelOfCareId] : [],
          fromDateOfBirth: fromDate ? formatStartDateSql(fromDate) : null,
          toDateOfBirth: endDate ? formatEndDateSql(endDate) : null,
          locations: this.locationId ? [this.locationId] : [],
          page: 1,
          pageSize: 50,
          providerId: provider
        },
        {
          "Hide-Loading": true
        }
      );
      this.eocs = eocs.episodesOfCare.map(eoc => ({
        value: eoc.id,
        label: this.formatEocObj(eoc),
        data: eoc
      }));
    },
    nameFilterClear() {
      this.filteredSelection = false
      if (this.name != "") {
        this.name = "";
        this.filterEocs();
      }
    },
    locFilterClear() {
      this.filteredSelection = false
      if (this.loc != null) {
        this.loc = null;
        this.filterEocs();
      }
    },
    statusFilterClear() {
      this.filteredSelection = false
      this.status = null;
      this.filterEocs();
    },
    dateFilterClear() {
      this.filteredSelection = false
      this.startDateFilter = "";
      this.endDateFilter = "";
      this.filterEocs();
    },
    dateAppFilterClear() {
      this.filteredSelection = false
      this.startAppDateFilter = "";
      this.endAppDateFilter = "";
      this.filterEocs();
    },
    providerFilterClear() {
      this.filteredSelection = false
      if (this.provider != null) {
        this.provider = null;
        this.filterEocs();
      }
    },
    statusVariant(status) {
      switch (status) {
        case "Pending":
          return "warning";
        case "Active":
          return "success";
        case "Inactive":
          return "danger";
        case "Draft":
          return "danger";
        default:
          return "";
      }
    },
    statusText(status) {
      return status;
    },
    resetValues() {
      this.name = "";
      this.startDateFilter = "";
      this.endDateFilter = "";
      this.startAppDateFilter = "";
      this.endAppDateFilter = "";
      this.eocs = this.data;
      this.loc = null;
      this.provider = null;
      this.allSelected = false;
      this.selectedValues = [];
      this.status = null;
      this.isCloseable = false;
      this.isLastPage = false;
      this.filteredSelection = false;
      this.filterEocs()
    },
    closeModal() {
      this.$emit("onModify");
    }
  },
  computed: {
    ...mapGetters("client", {
      levelsOfCareCurrentLocation: "levelsOfCareCurrentLocation"
    }),
    ...mapState("layout", {
      currentTenant: state => state.systemSetting.currentTenant,
      signalRAppUrl: state => state.systemSetting.signalRAppUrl
    })
  },
  watch: {
    selectedValues(value) {
      if (value.length === this.data.length) this.allSelected = true;
      else this.allSelected = false;
    }
  }
};
</script>

<style scoped>
.doc-list-group {
  border-bottom: 0;
  margin-top: 10px;
  max-height: 515px;
  min-width: 315px;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}
.doc-list-item {
  border-top: 0;
  border-left: 0;
  border-right: 0;
}
.select-filter {
  width: 30%;
  display: inline-block;
}
.close-icon {
  font-size: 20px;
}
::v-deep .modal-content {
  width: 815px;
}
</style>
